import { render, staticRenderFns } from "./ListSubjectTypes.vue?vue&type=template&id=5b7d736a&"
import script from "./ListSubjectTypes.vue?vue&type=script&lang=js&"
export * from "./ListSubjectTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7d736a')) {
      api.createRecord('5b7d736a', component.options)
    } else {
      api.reload('5b7d736a', component.options)
    }
    module.hot.accept("./ListSubjectTypes.vue?vue&type=template&id=5b7d736a&", function () {
      api.rerender('5b7d736a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/docDigital/components/subject/ListSubjectTypes.vue"
export default component.exports